import { InvestableComponentParameters } from './investable-component-parameters';
import { Product } from './product.model';

export class InvestableParameters {
  public trading_budget: number = 0.1;
  public trading_budget_min: number = 0;
  public trading_budget_max: number = 1.0;
  public additional_cash: number = 0.1;
  public additional_cash_min: number = 0;
  public additional_cash_max: number = 1.0;

  public target_volatility: number;
  public min_volatility: number;
  public max_volatility: number;
  public target_tracking_error: number;
  public min_tracking_error: number;
  public max_tracking_error: number;

  public has_weight_constraints: boolean = false;
  public has_best_fit: boolean = false;
  public has_remove_weight_constraints: boolean = false;
  public has_volatility_constraints: boolean = false;
  public has_tracking_error_constraints: boolean = false;
  public quarterly_rebalancing: string = 'automatic';

  public components: InvestableComponentParameters[] = [];
  public completeness: InvestableComponentParameters[] = [];
  public completeness_products: Product[] = [];

  // initialize current portfolio from JS object
  initFromData(data: any) {
    if (data==undefined) {return}

    this.trading_budget        = data.trading_budget;
    this.trading_budget_min    = data.trading_budget_min;
    this.trading_budget_max    = data.trading_budget_max;
    this.additional_cash       = data.additional_cash;
    this.additional_cash_min   = data.additional_cash_min;
    this.additional_cash_max   = data.additional_cash_max;
    this.quarterly_rebalancing = data.quarterly_rebalancing;

    this.setComponents(data.components);
  }

  setComponents(components_data: any) {
    if (components_data) {
      this.components = components_data.map((data_component) => {
        let component = new InvestableComponentParameters();
        component.initFromData(data_component);
        return component;
      });
    }
    this.checkWeightConstraints();
  }

  removeConstraints() {
    this.components.forEach((component) => {
      component.removeConstraints();
    })
  }

  fivePercents() {
    this.components.forEach((component) => {
      component.fivePercents();
    })
  }

  checkWeightConstraints() {
    let has_constraints = false;
    this.components.forEach((component) => {
      has_constraints = has_constraints || component.checkWeightConstraints();
    });
    this.has_weight_constraints = has_constraints;
  }

  checkConstraints() {
    this.checkVolatility();
    this.checkTrackingError();
  }

  checkVolatility() {
    if (this.max_volatility<this.min_volatility) {
      const vol = this.max_volatility;
      this.max_volatility = this.min_volatility;
      this.min_volatility = vol;
    }
    this.min_volatility = (this.target_volatility<this.min_volatility) ? this.target_volatility : this.min_volatility;
    this.max_volatility = (this.target_volatility>this.max_volatility) ? this.target_volatility : this.max_volatility;
  }

  checkTrackingError() {
    if (this.max_tracking_error<this.min_tracking_error) {
      const vol = this.max_tracking_error;
      this.max_tracking_error = this.min_tracking_error;
      this.min_tracking_error = vol;
    }
    this.min_tracking_error = (this.target_tracking_error<this.min_tracking_error) ? this.target_tracking_error : this.min_tracking_error;
    this.max_tracking_error = (this.target_tracking_error>this.max_tracking_error) ? this.target_tracking_error : this.max_tracking_error;
  }

  resetImproveConstraints() {
    this.has_best_fit = false;
    this.has_remove_weight_constraints = false;
    this.has_volatility_constraints = false;
    this.has_tracking_error_constraints = false;
  }
}